import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { config } from './config.js';

let client: SupabaseClient | null = null;

/** The session lives in this origin's localStorage: the app owns its sign-in and shares it with nothing. */
export function supabase(): SupabaseClient {
  if (client) return client;
  const c = config();
  client = createClient(c.supabaseUrl, c.supabasePublishableKey, {
    // detectSessionInUrl stays OFF: with it on, supabase-js auto-exchanges the ?code on the callback
    // page and deletes the one-time PKCE verifier, so the callback's own exchange then fails with
    // "code verifier not found". Exactly one exchange runs, in auth-callback.tsx.
    auth: { storageKey: 'studio-auth', flowType: 'pkce', persistSession: true, autoRefreshToken: true, detectSessionInUrl: false },
  });
  return client;
}

export async function accessToken(): Promise<string | null> {
  const { data } = await supabase().auth.getSession();
  return data.session?.access_token ?? null;
}
